const CLI_RELAY_PORTS = new Set(['8765', '8766', '8767']);
const CLI_STATE_PATTERN = /^[A-Za-z0-9_-]{32,256}$/;

/** Build a safe one-time request for the locally running CLI login callback. */
export function buildCliRelayRequest(search: string, token: string) {
    const params = new URLSearchParams(search || '');
    const rawRedirect = params.get('cli_redirect');
    const state = params.get('cli_state') || '';
    if (!rawRedirect || !token || !CLI_STATE_PATTERN.test(state)) return null;

    let redirect: URL;
    try {
        redirect = new URL(rawRedirect);
    } catch (_) {
        return null;
    }
    if (
        redirect.protocol !== 'http:' ||
        redirect.hostname !== 'localhost' ||
        !CLI_RELAY_PORTS.has(redirect.port) ||
        redirect.pathname !== '/callback' ||
        redirect.username ||
        redirect.password ||
        redirect.search ||
        redirect.hash
    ) return null;

    return {
        url: redirect.toString().replace(/\/$/, ''),
        body: new URLSearchParams({token, state}),
    };
}
